<script>
import { markRaw } from 'vue';

import MixinList from '@/Libs/Mixins/ListTab.js';

import InviteFormSidebar from '@/Libs/Pages/Panel/Branch/Part/InviteFormSidebar.vue';

export default {
    mixins: [MixinList],
    props: {
        branch: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            inviteFormSidebar: markRaw(InviteFormSidebar),

            routeName: 'branch-detail',
            tabName: 'employee',
            employee_alert: true
        }
    },
    methods: {
        async _search(search) {
            search.order_by = 'user';
            search.sort_by = 'asc';

            return await this.$api.Employee.all(search);
        },
        async _delete(params) {
            return await this.$api.Employee.delete(params);
        },
        // ======
        doSearch() {
            if (this.search.order_by)
                this.search.order_by = this.$orderBy.toString();

            this.$router.replace({ name: 'branch-detail', params: { id: this.$route.params.id }, query: this.search });
        },
        _beforeSearch(search) {
            var vm = this;

            search.branch_id = vm.$route.params.id;

            search.status = 'approved';
            if (vm.$route.query.status)
                search.status = vm.$route.query.status;

            delete search.tabIndex;

            return search;
        },
        async onRefresh() {
            await this._doSearch();
        }
    }
};
</script>

<template>
    <BRow class="g-4 align-items-center mb-3">
        <BCol sm="auto">
            <div class="d-flex flex-wrap align-items-start gap-2">
                <btn-sidebar variant="success"
                    v-if="$ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_create') && $ac.hasAccessStore(branch.store_id))"
                    :sidebar="inviteFormSidebar"
                    :data="{ branch: branch }"
                    :success="onRefresh">
                    <i class="mdi mdi-share-variant-outline align-bottom me-1"></i> {{ $t('employee.btn.invite') }}
                </btn-sidebar>
                <BButton type="button" variant="warning"
                    :disabled="$loading.get([routeName, tabName, 'list'].join('_'))"
                    @click="$router.push({ name: 'branch-detail', params: { id: this.$route.params.id }, query: { ...search, status: 'pending' } })"
                    v-if="($ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_list') && $ac.hasAccessStore(branch.store_id))) &&
                        (!$route.query.status || $route.query.status == 'approved')">
                    <i class="mdi mdi-email-alert-outline align-bottom me-1"></i> {{ $t('employee.btn.pending') }}
                </BButton>
                <BButton type="button" variant="primary"
                    :disabled="$loading.get([routeName, tabName, 'list'].join('_'))"
                    @click="$router.push({ name: 'branch-detail', params: { id: this.$route.params.id }, query: { ...search, status: 'approved' } })"
                    v-if="($ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_list') && $ac.hasAccessStore(branch.store_id))) &&
                        $route.query.status == 'pending'">
                    <i class="mdi mdi-account-tie-outline align-bottom me-1"></i> {{ $t('employee.btn.approved') }}
                </BButton>
                <BButton type="button" variant="info"
                    @click="$router.push({ name: 'employee', query: { branch_id: $route.params.id } })"
                    v-if="$ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_list') && $ac.hasAccessStore(branch.store_id))">
                    <i class="mdi mdi-format-list-text align-bottom me-1"></i> {{ $t('basic.btn.more') }}
                </BButton>
            </div>
        </BCol>
        <BCol sm>
            <div class="d-flex justify-content-sm-end">
                <div class="search-box ms-2">
                    <b-form @submit="doSearch()">
                        <input type="text" class="form-control" v-model="search.keyword"
                            :placeholder="$t('filter.placeholder.keyword')" />
                        <i class="mdi mdi-magnify search-icon"></i>
                    </b-form>
                </div>
            </div>
        </BCol>
    </BRow>
    <BRow v-if="$route.query.status == 'pending'">
        <BCol>
            <BAlert dismissible :model-value="true" v-model="employee_alert" variant="info"
                class="alert-border-left shadow">
                <i class="mdi mdi-information-outline align-middle fs-16"></i>
                {{ $t('employee.info.pending') }}
            </BAlert>
        </BCol>
    </BRow>
    <BRow class="gy-2 mb-2">
        <BCol lg="12">
            <div class="table-responsive">
                <loading :loading="$loading.get([routeName, tabName, 'list'].join('_'))" variant="dark" type="block">
                    <BListGroup tag="ul" class="mb-1">
                        <BListGroupItem tag="li" v-for="(tr, index) of list" :key="index"
                            :class="{ 'bg-warning-subtle': tr.status_name == 'pending', 'bg-success-subtle': tr.status_name == 'approved' }"
                            class="mb-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center flex-grow-1">
                                    <div class="flex-shrink-0 avatar-sm">
                                        <div class="avatar-title rounded text-light" :key="index"
                                            :class="{ 'bg-warning': tr.status_name == 'pending', 'bg-success': tr.status_name == 'approved' }">
                                            <i class="mdi mdi-account-tie-outline fs-4"></i>
                                        </div>
                                    </div>
                                    <div class="ms-3">
                                        <h6 class="mb-0">{{ tr.user }}</h6>
                                        <small class="text-muted d-block">{{ tr.user_ref_no }}</small>
                                        <small class="text-muted d-block">{{ $dateFormat.datetime(tr.created_at)
                                            }}</small>
                                    </div>
                                </div>
                                <div class="ms-3 flex-shrink-0"
                                    v-if="$ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_delete') && $ac.hasAccessStore(branch.store_id))">
                                    <BButton variant="danger" size="sm" @click.prevent="destroy(tr.id)"
                                        :disabled="$loading.get([routeName, tabName, 'delete', tr.id].join('_'))">
                                        <loading
                                            :loading="$loading.get([routeName, tabName, 'delete', tr.id].join('_'))"
                                            variant="light" type="button">
                                            <i class="mdi mdi-delete-outline fs-16"></i>
                                            {{ $t('basic.btn.delete') }}
                                        </loading>
                                    </BButton>
                                </div>
                            </div>
                        </BListGroupItem>
                    </BListGroup>
                </loading>
            </div>
        </BCol>
    </BRow>
    <BRow class="g-0 justify-content-end mb-4 mt-3" id="pagination-element">
        <BCol sm="6">
            <pagination v-bind:model="paginator" v-on:goto="goto"
                :disabled="$loading.get([routeName, 'list'].join('_'))" />
        </BCol>
    </BRow>
</template>